"use client";
import React from "react";
import useTextColorBasedOnBackground from "@/src/hooks/useTextColorBasedOnBackground";
import { AdaptiveListItemProps } from "./types";

const AdaptiveListItem: React.FC<
  AdaptiveListItemProps & { onClick: () => void }
> = ({ item, itemWidth, onClick }) => {
  const textColorClass = useTextColorBasedOnBackground(item.list_item_color);

  return (
    <li
      className={`px-4 py-3 font-bold text-center rounded-md flex items-center justify-center cursor-pointer ${textColorClass}`}
      style={{
        backgroundColor: item.list_item_color,
        minWidth: itemWidth === "auto" ? "150px" : `${itemWidth}px`,
        maxWidth: "100%",
        whiteSpace: "nowrap",
      }}
      onClick={onClick}
    >
      {item.button}
    </li>
  );
};

export default AdaptiveListItem;
